var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "comment-wrap"
  }, [_c("div", {
    staticClass: "comment-input-wrap"
  }, [_c("div", {
    staticClass: "input-div",
    attrs: {
      placeholder: "发个评论~~"
    },
    on: {
      click: _vm.commentFocus
    }
  }, [_vm._v("发个评论~~")]), _c("img", {
    staticClass: "emoji",
    attrs: {
      src: require("@/assets/images/live/btn_live_emoji_normal@2x.png")
    },
    on: {
      click: _vm.openEmoji
    }
  })]), _c("div", {
    staticClass: "icon-wrap",
    on: {
      click: _vm.openDanmu
    }
  }, [_vm.danmuOpen ? _c("img", {
    staticClass: "danmu",
    attrs: {
      src: require("@/assets/images/live/btn_live_dan_normal@2x.png")
    }
  }) : _c("img", {
    staticClass: "danmu",
    attrs: {
      src: require("@/assets/images/live/btn_live_dan_disable@2x.png")
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };